import React from 'react';

const SupplementNotFound = () => (
  <div className='supplement-not-found'>The requested supplement was not found.</div>
);

export default SupplementNotFound;
